module.exports = __webpack_public_path__ + "static/fonts/Fact-LightItalic.a30267f.woff2";